/**
 * Datetime Field Type enum
 *
 * @package ext-components-base
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum DATETIME_FIELD_TYPE {
	DATETIME = "datetime",
	DATETIME_FULL = "datetime-full",
	DATE = "date",
	TIME = "time",
	TIME_FULL = "time-full"
	//MONTH = "month"
}

export type DATETIME_FIELD_TYPE_string = keyof typeof DATETIME_FIELD_TYPE;

export const DATETIME_FIELD_TYPE_default: DATETIME_FIELD_TYPE_string = "DATETIME";
